import { useState } from 'react'
import { router } from '@inertiajs/react'
import { reset_admin_import_path } from '@/lib/routes'
import { Button } from '@/components/ui/Button'

interface ResetIncrementalModalProps {
  id: string
  name: string
  targetCount: number | null
  onClose: () => void
}

export default function ResetIncrementalModal({
  id,
  name,
  targetCount,
  onClose,
}: ResetIncrementalModalProps) {
  const [startDate, setStartDate] = useState('')
  const [processing, setProcessing] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    setProcessing(true)
    router.post(
      reset_admin_import_path(id),
      { start_date: startDate },
      { onFinish: () => setProcessing(false), onSuccess: onClose },
    )
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className="relative z-10 w-full max-w-md rounded-lg bg-background border p-6 shadow-lg">
        <h2 className="text-lg font-semibold mb-4">Reset “{name}”</h2>
        <div className="mb-4 rounded-md border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive">
          This deletes{' '}
          <span className="font-medium">
            {targetCount != null ? `${targetCount.toLocaleString()} existing rows` : 'all existing rows'}
          </span>{' '}
          and rewinds the sync cursor. You will need to click “Sync Now” afterward to re-pull the data.
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Start syncing from</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="w-full rounded-md border border-input bg-background px-3 py-2 text-sm"
              required
            />
            <p className="text-xs text-muted-foreground mt-1">
              The first date that will be re-synced from Metabase.
            </p>
          </div>
          <div className="flex justify-end gap-2 mt-2">
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" variant="destructive" disabled={processing || !startDate}>
              {processing ? 'Resetting...' : 'Delete & Reset'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  )
}
